"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var UserSettingsForm_module_css_1 = __importDefault(require("./UserSettingsForm.module.css"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var BrowserSessions = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("form", { id: UserSettingsForm_module_css_1.default.contentContainer },
        react_1.default.createElement("div", { id: UserSettingsForm_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.title },
                react_1.default.createElement("span", null, t("Browser Sessions"))),
            react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.inputContainer },
                react_1.default.createElement(Label_1.default, { htmlFor: "browserSessions", className: UserSettingsForm_module_css_1.default.label }, t("Manage and log out your active sessions on other browsers and devices. If necessary, you may log out of all of your other browser sessions across all of your devices. Some of your recent sessions are listed below; however, this list may not be exhaustive. If you feel your account has been compromised, you should also update your password."))))));
};
exports.default = BrowserSessions;
